import { render, staticRenderFns } from "./CommitModal.vue?vue&type=template&id=cc406550&scoped=true&"
import script from "./CommitModal.vue?vue&type=script&lang=js&"
export * from "./CommitModal.vue?vue&type=script&lang=js&"
import style0 from "./CommitModal.vue?vue&type=style&index=0&id=cc406550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc406550",
  null
  
)

export default component.exports